import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { supabase } from '../services/supabase';
import { Button, Stack, TextField } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import PhoneIcon from '@mui/icons-material/Phone';
import FacebookIcon from '@mui/icons-material/Facebook';

// eslint-disable-next-line react-refresh/only-export-components
export const handleTestSignUp = async (): Promise<void> => {
  try {
    const { error: signUpError } = await supabase.auth.signUp({
      email: 'flik930@hotmail.com',
      password: '000000',
      options: {
        emailRedirectTo: `${window.location.origin}/email-success`,
      }
    });

    if (signUpError) {
      toast.error(signUpError.message);
      return;
    }

    toast.success('Test sign up successful!');
  } catch (error) {
    toast.error((error instanceof Error ? error.message : undefined) || 'Test sign up failed');
  }
};

// eslint-disable-next-line react-refresh/only-export-components
export const handleResendVerificationEmail = async (): Promise<void> => {
  try {
    const { error } = await supabase.auth.resend({
      type: 'signup',
      email: 'flik930@hotmail.com',
    });

    if (error) {
      toast.error(error.message);
      return;
    }

    toast.success('Verification email resent successfully!');
  } catch (error) {
    toast.error((error instanceof Error ? error.message : undefined) || 'Failed to resend verification email');
  }
};

// eslint-disable-next-line react-refresh/only-export-components
export const handleTestSignIn = async (): Promise<void> => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: 'flik930@hotmail.com',
      password: '000000',
    });

    if (error) {
      toast.error(error.message);
      return;
    }

    toast.success('Sign in successful!');
    console.log('Sign in data:', data);
  } catch (error) {
    toast.error((error instanceof Error ? error.message : undefined) || 'Sign in failed');
  }
};

// eslint-disable-next-line react-refresh/only-export-components
export const handleGoogleSignIn = async (): Promise<void> => {
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      }
    });

    if (error) {
      toast.error(error.message);
      return;
    }

    toast.success('Google authentication initiated');
    console.log('Google auth data:', data);
  } catch (error) {
    toast.error((error instanceof Error ? error.message : undefined) || 'Google sign in failed');
  }
};

// eslint-disable-next-line react-refresh/only-export-components
export const handleFacebookSignIn = async (): Promise<void> => {
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'facebook',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      }
    });

    if (error) {
      toast.error(error.message);
      return;
    }

    toast.success('Facebook authentication initiated');
    console.log('Facebook auth data:', data);
  } catch (error) {
    toast.error((error instanceof Error ? error.message : undefined) || 'Facebook sign in failed');
  }
};

// eslint-disable-next-line react-refresh/only-export-components
export const handlePhoneOtpSignIn = async (): Promise<void> => {
  try {
    // Use a test phone number in international format


    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: 'flik930@hotmail.com',
      password: '000000',
    });

    if (signInError) {
      toast.error(signInError.message);
      return;
    }

    const { error: updateError } = await supabase.auth.updateUser({
      phone: '85267396213',
    });

    if (updateError) {
      toast.error(updateError.message);
      return;
    }

    const phoneNumber = '85267396213';

    const { data, error } = await supabase.auth.signInWithOtp({
      phone: phoneNumber,
      options: {
        // If you need to customize OTP delivery options
        // channel: 'sms',
      }
    });

    if (error) {
      toast.error(error.message);
      return;
    }

    toast.success(`OTP sent to ${phoneNumber}. Check your phone for the verification code.`);
    console.log('Phone OTP data:', data);

    // Typically you would now prompt user to enter the OTP code
    // and then verify it with supabase.auth.verifyOtp()
  } catch (error) {
    toast.error((error instanceof Error ? error.message : undefined) || 'Failed to send OTP to phone');
  }
};

// eslint-disable-next-line react-refresh/only-export-components
export const handleVerifyPhoneOtp = async (otp: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase.auth.verifyOtp({
      phone: '85267396213',
      token: otp,
      type: 'sms'
    });

    if (error) {
      toast.error(error.message);
      return false;
    }

    toast.success('Phone number verified successfully!');
    console.log('Verification data:', data);
    return true;
  } catch (error) {
    toast.error((error instanceof Error ? error.message : undefined) || 'OTP verification failed');
    return false;
  }
};

export const TestingButtons: React.FC = () => {
  // Set this to false to disable test buttons
  const ENABLE_TESTING = false;
  const [otp, setOtp] = useState<string>('');

  const handleOtpSend = async (): Promise<void> => {
    await handlePhoneOtpSignIn();
  };

  const handleVerify = async (): Promise<void> => {
    if (!otp) {
      toast.error('Please enter OTP code');
      return;
    }
    await handleVerifyPhoneOtp(otp);
  };

  if (!ENABLE_TESTING) return null;

  return (
    <Stack direction="column" spacing={2} sx={{ mb: 3 }}>
      <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleTestSignUp}
        >
          Test Sign Up
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleResendVerificationEmail}
        >
          Resend Verification Email
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={handleTestSignIn}
        >
          Test Sign In
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleGoogleSignIn}
          startIcon={<GoogleIcon />}
        >
          Google Sign In
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFacebookSignIn}
          startIcon={<FacebookIcon />}
          sx={{ bgcolor: '#1877F2', '&:hover': { bgcolor: '#166FE5' } }}
        >
          Facebook Sign In
        </Button>
        <Button
          variant="contained"
          color="info"
          onClick={handleOtpSend}
          startIcon={<PhoneIcon />}
        >
          Phone OTP Sign In
        </Button>
      </Stack>

      {(
        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            label="Enter OTP Code"
            variant="outlined"
            value={otp}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOtp(e.target.value)}
            placeholder="Enter 6-digit code"
          />
          <Button
            variant="contained"
            color="success"
            onClick={handleVerify}
          >
            Verify OTP
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
